const relatedRecommendationsSelector = 'product-recommendations.related-products[data-product-id]';

document.addEventListener("DOMContentLoaded", function () {
    initializeRelatedProductRecommendations();
    featuredProductSlider();
    customerSlider();
});

window.addEventListener('resize', featuredProductSlider);
window.addEventListener('resize', equalizeAllRelatedProductCardHeights);
window.addEventListener('load', function () {
    initializeRelatedProductRecommendations();
    equalizeAllRelatedProductCardHeights();
});

function initializeRelatedProductRecommendations() {
    const sections = document.querySelectorAll(relatedRecommendationsSelector);
    sections.forEach((section) => {
        if (section.dataset.relatedObserverAttached === 'true') return;

        const observer = new MutationObserver(() => {
            const $grid = $(section).find('.product-grid');
            if ($grid.length > 0) {
                productRecSlider($grid);
            }
        });

        observer.observe(section, { childList: true, subtree: true });
        section.dataset.relatedObserverAttached = 'true';

        const $grid = $(section).find('.product-grid');
        if ($grid.length > 0) {
            productRecSlider($grid);
        }
    });
}

function equalizeRelatedProductCardHeights($grid) {
    if (!$grid || $grid.length === 0) return;

    let $cards = $grid.hasClass('slick-initialized')
        ? $grid.find('.slick-slide:not(.slick-cloned) .product-card-wrapper .cr-card')
        : $grid.find('> .grid__item .product-card-wrapper .cr-card');

    if ($cards.length === 0) {
        $cards = $grid.hasClass('slick-initialized')
            ? $grid.find('.slick-slide:not(.slick-cloned) .product-card-wrapper')
            : $grid.find('> .grid__item .product-card-wrapper');
    }

    if ($cards.length === 0) return;

    $cards.css('min-height', '');
    $cards.closest('.product-card-wrapper').css('min-height', '');
    $cards.closest('.product-card-wrapper').find('.card').css('min-height', '');

    let maxHeight = 0;
    $cards.each(function () {
        const height = $(this).outerHeight();
        if (height > maxHeight) maxHeight = height;
    });

    if (maxHeight > 0) {
        const minHeightValue = `${Math.ceil(maxHeight)}px`;
        $cards.css('min-height', minHeightValue);

        // Keep wrapper and card in sync so visual container heights always match.
        $cards.closest('.product-card-wrapper').css('min-height', minHeightValue);
        $cards.closest('.product-card-wrapper').find('.card').css('min-height', minHeightValue);
    }
}

function equalizeAllRelatedProductCardHeights() {
    $(`${relatedRecommendationsSelector} .product-grid`).each(function () {
        equalizeRelatedProductCardHeights($(this));
    });
}

function bindRelatedProductGridEvents($grid) {
    if (!$grid || $grid.length === 0) return;

    $grid.off('setPosition.relatedHeight afterChange.relatedHeight')
        .on('setPosition.relatedHeight afterChange.relatedHeight', function () {
            equalizeRelatedProductCardHeights($grid);
        });

    $grid.find('img').off('load.relatedHeight').on('load.relatedHeight', function () {
        equalizeRelatedProductCardHeights($grid);
    });
}

function productRecSlider($targetGrid) {
    const $productGrid = $targetGrid && $targetGrid.length ? $targetGrid : $(`${relatedRecommendationsSelector} .product-grid`);
    if ($productGrid.length === 0) return;

    $productGrid.each(function () {
        const $grid = $(this);

        if (!$grid.hasClass('slick-initialized')) {
            $grid.slick({
                dots: false,
                centerMode: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '60px',
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            });
        }

        bindRelatedProductGridEvents($grid);
        equalizeRelatedProductCardHeights($grid);
        setTimeout(() => equalizeRelatedProductCardHeights($grid), 120);
        setTimeout(() => equalizeRelatedProductCardHeights($grid), 500);
    });
}

function featuredProductSlider() {
    const $featuredProducts = $('.featured-product__slider-wrapper');

    if ($featuredProducts.length === 0) return;

    if (window.innerWidth < 750) {
        if (!$featuredProducts.hasClass('slick-initialized')) {
            $featuredProducts.slick({
                dots: true,
                centerMode: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                arrows: false
            });
        }
    } else {
        if ($featuredProducts.hasClass('slick-initialized')) {
            $featuredProducts.slick('unslick');
        }
    }
}

function customerSlider() {
    const $customerSlider = $('.sr-customer-slider__content');
    if ($customerSlider.length > 0) {
        $customerSlider.slick({
            dots: false,
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        centerPadding: '40px',
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });
    }
}
